export default __webpack_public_path__ + "static/media/googleIcon.496ac98b.svg";